import { PagingResultsViewModel, FilterSearchingBaseViewModel, EnumSiNoTodos } from '../../../core/_infrastructure/types/common';

export class PaisItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: PaisViewModel[];
}

export class PaisViewModel {
    constructor() {}

    public Id: number;
    public Descripcion: string = '';
    public DescripcionIngles: string = '';
    public ConvenioIso: string = '';
    public Habilitado: boolean = true;
    public UsaCodigoPostal: boolean = true;
    public ConvenioIsoTraces: string = '';
    public EPhytoCanReceive: boolean = false;
}

export class FilterSearchingPaisViewModel extends FilterSearchingBaseViewModel {
    public Descripcion: string = '';
    public DescripcionIngles: string = '';
    public ConvenioIso: string = '';
    public Habilitado: number = EnumSiNoTodos.TODOS;
    public UsaCodigoPostal: number = EnumSiNoTodos.TODOS;
    public ConvenioIsoTraces: string = '';
    public EPhytoCanReceive: number = EnumSiNoTodos.TODOS;
}
